<template>
  <div class="home">
    <home-banner
      :members="members"
      :countries="countries"
      :cities="cities"
      :events="events"
    ></home-banner>
    <home-members-in-cities></home-members-in-cities>
    <home-sponsors></home-sponsors>
    <home-thoughts></home-thoughts>
    <home-initiatives></home-initiatives>
    <home-event-jobs :events="eventList" :jobs="jobs"></home-event-jobs>
    <home-community-podcast :podcasts="podcasts"></home-community-podcast>
    <home-invite></home-invite>
  </div>
</template>

<script>
import { Members, Countries, Events, Cities } from '@/gql/Home.gql';
import listEvents from '@/newgql/ListUpcomingEvents.gql';
import ListRecentJobs from '@/newgql/ListRecentJobs.gql';
import ListPodcastEpisodes from '@/newgql/ListPodcastEpisodes.gql';
import HomeBanner from '@/components/home/Banner.vue';
import HomeSponsors from '@/components/home/Sponsors.vue';
import HomeMembersInCities from '@/components/home/MembersInCities.vue';
import HomeThoughts from '@/components/home/Thoughts.vue';
import HomeInitiatives from '@/components/home/Initiatives.vue';
import HomeEventJobs from '@/components/home/EventJobs.vue';
import HomeCommunityPodcast from '@/components/home/CommunityPodcast.vue';
import HomeInvite from '@/components/home/Invite.vue';

export default {
  name: 'home',

  components: {
    HomeBanner,
    HomeSponsors,
    HomeMembersInCities,
    HomeThoughts,
    HomeInitiatives,
    HomeEventJobs,
    HomeCommunityPodcast,
    HomeInvite
  },

  apollo: {
    members: Members,
    countries: Countries,
    cities: Cities,
    events: Events,
    event: {
      query: listEvents,
      variables() {
        return {
          today: this.$moment()
        };
      }
    },
    jobs: ListRecentJobs,
    podcasts: ListPodcastEpisodes
  },

  data() {
    return {};
  },

  computed: {
    eventList() {
      return this.event;
    }
  }
};
</script>

<style lang="scss" scoped></style>
